import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store/store'
import mixins from './mixin/mixins'
import router from './router'
import i18n from './i18n'
import CountryFlag from 'vue-country-flag'
import arraySetup from './tools/array'
import VueMask from 'v-mask'
import '@colven/common-components'
import '@colven/common-components/dist/gestyaCommonComponents.css'
import wb from "./registerServiceWorker"
Vue.prototype.$workbox = wb
Vue.config.productionTip = false

arraySetup()
mixins()
Vue.component('country-flag', CountryFlag)
Vue.use(VueMask)

// global event bus
Vue.prototype.$eventBus = new Vue()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
